import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline, Circle, Tooltip, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export const LOME = [6.1725, 1.2314];

export const pin = (label, color = "#076633", size = 30) => L.divIcon({
  className: "",
  iconSize: [size, size],
  iconAnchor: [size / 2, size / 2],
  html: `<div style="width:${size}px;height:${size}px;border-radius:9999px;background:${color};color:#fff;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;font:700 11px/1 monospace">${label}</div>`,
});

function Fit({ points }) {
  const map = useMap();
  const key = JSON.stringify(points);
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 15);
    else if (points.length > 1) map.fitBounds(points, { padding: [30, 30] });
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

function ClickCatcher({ onClick }) {
  useMapEvents({ click: (e) => onClick && onClick(e.latlng) });
  return null;
}

// markers = [{ id, pos:[lat,lng], label, color, popup }], lines = [{ id, points, color, dashed }]
// circles = [{ id, center:[lat,lng], radiusKm, color, label }]
export default function ViMap({ markers = [], lines = [], circles = [], onClick, height = 360, testid = "vi-map" }) {
  const pts = markers.map((m) => m.pos);
  return (
    <div className="rounded-xl overflow-hidden border relative z-0" style={{ height }} data-testid={testid}>
      <MapContainer center={pts[0] || LOME} zoom={13} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Fit points={pts} />
        <ClickCatcher onClick={onClick} />
        {lines.filter((l) => l.points.length > 1).map((l) => <Polyline key={l.id} positions={l.points} pathOptions={{ color: l.color || "#076633", weight: 4, opacity: 0.7, dashArray: l.dashed ? "6 8" : null }} />)}
        {circles.map((c) => (
          <Circle key={c.id} center={c.center} radius={c.radiusKm * 1000} pathOptions={{ color: c.color || "#076633", weight: 2, fillOpacity: 0.06, dashArray: c.dashed ? "5 6" : null }}>
            {c.label && <Tooltip>{c.label}</Tooltip>}
          </Circle>
        ))}
        {markers.map((m) => (
          <Marker key={m.id} position={m.pos} icon={pin(m.label, m.color, m.size)}>
            {m.popup && <Popup>{m.popup}</Popup>}
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
